module.exports = {
    name: "default",
    default: {
        variableLess: "../src/assets/styles/theme/default.less"
    }
};



//////////////////
// WEBPACK FOOTER
// ./config/system.js
// module id = mvz5
// module chunks = 39